export { default as FreeCheckbox } from './FreeCheckbox.vue';
